import Vue from 'vue'
import Router from 'vue-router'

import AuthLogin from '@/components/auth/AuthLogin'
import SideRegister from '@/components/auth/SideRegister'
import Navigation from '@/components/navigation/Navigation'
import PageNotFound from '@/components/page/NotFound'

import account from './modules/account'
import admin from './modules/admin'
import auth from './modules/auth'
import user from './modules/user'
import watch from './modules/watch'
import support from './modules/support'

import statics from './modules/statics'

Vue.use(Router)

const routes = [
	// Homepage
	{
		path: '',
		name: 'HomePage',
		redirect: {
			name: 'AuthLogin'
		}
	},
	// Redirect other routes
	/* {
		path: '*',
		redirect: '/dashboard'
	} */
	{
		path: '*',
		components: {
			default: PageNotFound,
			//menu: Navigation // Can't show navigation here because the user might be anonymous (not logged in)
		},
	}
]

export default new Router({
	mode: 'history',
	// hashbang: false,
	base: __dirname,
	routes: [
		...routes,
		...user,
		...account,
		...admin,
		...auth,
		...watch,
		...support,
		...statics
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js